import { createNotesContextProvider } from 'src/SharedCommonContext/GenericNotesContextFactory';

export const {
  NotesProvider: PropertyNotesProvider,
  useNotesDataFromContext: usePropertyNotesDataFromContext,
  useNotesActionsFromContext: usePropertyNotesActionsFromContext,
} = createNotesContextProvider({
  itemType: 'Property',
  displayName: 'property',
});
